<div *ngIf="activeFilteringOptions?.length" class="discover-active-filters-badges-wrapper">
  <div
    *ngFor="let filter of activeFilteringOptions"
    [reactComponent]="BadgeComponent$"
    [props]="{
      label: filter.shortLabel,
      imageUrl: filter.type === 'dietary' ? filter.icon : null,
      options: filter,
      onBadgeClick: onBadgeClickCallBack
    }"
  ></div>
</div>
